import axios from "axios";
import app from "./main";

axios.defaults.withCredentials = false;

const api3 = axios.create({
  baseURL: "https://currency-converter5.p.rapidapi.com",
  withCredentials: false,
  headers: {
    "x-rapidapi-key": "e68866d3cdmshcf3c4127d688b38p1b0a9fjsn8deb07a200fb",
    "x-rapidapi-host": "currency-converter5.p.rapidapi.com",
    "useQueryString": "true"
  },
});

api3.interceptors.request.use((config) => {
  app.$Progress.start(); // for every request start the progress
  return config;
});

api3.interceptors.response.use((response) => {
  app.$Progress.finish(); // finish when a response is received
  return response;
});

export default api3;
